import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=ed34d08c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=ed34d08c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed34d08c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed34d08c')) {
      api.createRecord('ed34d08c', component.options)
    } else {
      api.reload('ed34d08c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=ed34d08c&scoped=true&", function () {
      api.rerender('ed34d08c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n2LicZJZvGdt/JS/comp/PopupDialog.vue"
export default component.exports